import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';

type ErrorStateProps = {
  onRetry?: () => void;
};

const ErrorState = ({ onRetry }: ErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-2 text-center mt-8"
    >
      <h3 className="font-semibold text-destructive">
        {t('errorBoundary.title')}
      </h3>

      <p className="text-sm text-muted-foreground max-w-xs">
        {t('errorBoundary.description')}
      </p>

      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          {t('errorBoundary.returnHome')}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
